import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { useAppSelector } from '../../hooks';
import { TAccountClientContact, TAccountClientContactPayloadParams, TAccountClientContactResponse, adaptAccountClientContactFromResponse } from '../../types';
import { BACKEND_ACCOUNT_CLIENT } from '../../backend-paths';


export const accountClientContactReadGetApi = createAsyncThunk(
	`FETCH/${BACKEND_ACCOUNT_CLIENT}/:client_id/contacts/:id`,
	(payload: TAccountClientContactPayloadParams, thunkApi) => {
		const { id, clientId } = payload;
		const path = `${BACKEND_ACCOUNT_CLIENT}/${clientId}/contacts/${id}`;

		return HttpService.get<TAccountClientContactResponse>(path).then(result => {
			return adaptAccountClientContactFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

type TInitialState = {
	item: TAccountClientContact | undefined,
	isLoading: boolean,
	error?: HttpError,
};

const initialState: TInitialState = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const accountClientContactReadSlice = createSlice({
	name: 'accountClientContactReadSlice',
	initialState,
	reducers: {
		setAccountClientContactRead(state, action: PayloadAction<TAccountClientContact>) {
			state.item = action.payload;
		},

		clearAccountClientContactRead(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[accountClientContactReadGetApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[accountClientContactReadGetApi.fulfilled.type]: (state, action: PayloadAction<TAccountClientContact>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[accountClientContactReadGetApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useAccountClientContactReadSelector = () => useAppSelector(state => state[accountClientContactReadSlice.name]);

export const { clearAccountClientContactRead, setAccountClientContactRead } = accountClientContactReadSlice.actions;
